import axios from "axios";

// Optional: Create Function To Get Axios Instance Dynamically
export const createAxiosInstance = (currentToken) => {
  return axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {
      Authorization: currentToken ? `Bearer ${currentToken}` : "",
      "Content-Type": "application/json",
    },
  });
};
